import OapRating from './code/Scripts/components/OapRating.vue';

export default {
  components: {
    OapRating,
  },
};
